export default "__VITE_ASSET__BghpEzM6__"